import { ZEntryLine } from '@daymade/common-lib/dbJsonModels';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ZPrizeOrderInsert } from '../winner/models';
import {
  TokenRedemptionOptionTypeEnum,
  ZPurchaseTokensResponse,
  ZTokenRedemptionOrder,
} from './models';

const c = initContract();
export const authTokenContract = c.router(
  {
    redeemWithToken: {
      method: 'POST',
      path: '/token-redemption-option/:id/redeem',
      pathParams: z.object({
        id: z.coerce.number(),
      }),
      body: z.object({
        [TokenRedemptionOptionTypeEnum.PRIZE]: z
          .object({
            prizeId: z.coerce.number(),
            productId: z.coerce.number().optional(),
          })
          .merge(
            ZPrizeOrderInsert.pick({
              deliveryStreet: true,
              deliveryCity: true,
              deliveryPostcode: true,
              emailAddress: true,
              phoneNumber: true,
              additionalInfoFromPlayer: true,
            }),
          )
          .optional(),
        [TokenRedemptionOptionTypeEnum.ENTRY]: z
          .object({
            entries: ZEntryLine.array(),
            drawId: z.coerce.number().optional(),
          })
          .optional(),
        [TokenRedemptionOptionTypeEnum.TREE]: z
          .object({
            quantity: z.coerce.number().optional(),
          })
          .optional(),
      }),
      responses: {
        200: z.object({
          id: z.string(),
        }),
        400: z.object({
          message: z.string(),
          reason: z.string().optional(),
        }),
      },
    },
    getTokenRedemptionOrder: {
      method: 'GET',
      path: '/token-redemption/:id',
      responses: {
        200: z.array(ZTokenRedemptionOrder),
        400: z.object({
          message: z.string(),
        }),
      },
    },
    purchaseTokens: {
      method: 'POST',
      path: '/purchase-tokens',
      body: z.object({
        tokenAmount: z.number(),
        expectedCost: z.number(),
        sourceFor3DS: z.string().optional(),
      }),
      responses: {
        200: ZPurchaseTokensResponse,
        400: z.object({
          message: z.string(),
          reason: z
            .union([
              z.literal('ACCOUNT_SUSPENDED'),
              z.literal('WOULD_EXCEED_SPEND_LIMIT'),
            ])
            .optional(),
          spendLimitPence: z.number().optional(),
        }),
      },
    },
    getTokenBalanceForUser: {
      method: 'GET',
      path: '/token-balance',
      responses: {
        200: z.number(),
        400: z.object({
          message: z.string(),
        }),
      },
    },
  },
  {
    pathPrefix: '/auth',
    commonResponses: {
      401: c.type<{ message: 'Unauthorized'; statusCode: 401 }>(),
    },
  },
);
